import { getPromoDetails, applyPromo } from 'Api/AccountApi';
import { onSubmitReactFormError } from 'Utils/FormValidation';

import {
  SET_PROMO_CODE,
  INVALID_PROMO_CODE,
  RESET_PROMO_CODE,
  SET_EMAIL_COUPON,
  RESET_APPLIED_STATE,
  APPLY_EMAIL_COUPON,
} from '../Types';

export const invalidPromoCode = (payload) => ({ type: INVALID_PROMO_CODE, payload });
export const resetPromoCode = () => ({ type: RESET_PROMO_CODE });
export const setPromoCode = (payload) => ({ type: SET_PROMO_CODE, payload });
export const resetAppliedState = () => ({ type: RESET_APPLIED_STATE });

// to be used only for auto-filling coupon code using an email deeplink.
export const setEmailCoupon = (payload) => ({ type: SET_EMAIL_COUPON, payload });
// to be used only for automatically applying the coupon using an email deeplink.
export const autoApplyEmailCoupon = (payload) => ({ type: APPLY_EMAIL_COUPON, payload });

export const validatePromoCode = (couponCode, planId) => {
  return async (dispatch, getState) => {
    const {
      plans: { selectedPlanId },
      promoCode: { emailCoupon },
    } = getState();
    const plan = planId || selectedPlanId;
    if (!plan) {
      console.error('No plan selected', { couponCode, plan });
    }
    // if user enters the promo code, call evergent getVoucherDetails api
    if (couponCode && plan) {
      return getPromoDetails(plan, couponCode)
        .then((promoDetails) => {
          const { isValid, errorMessage, promoDescription, isFlatDiscount, priceToBeCharged, nextBillingDateTime } =
            promoDetails;
          if (isValid) {
            const validPromoCodeDetails = {
              couponCode,
              promoDescription,
              isFlatDiscount,
              nextBillingDateTime,
              hasApplied: true,
              plan,
              priceToBeCharged,
              validCouponCodeLabel: 'Your code has been applied.',
            };
            if (couponCode !== emailCoupon) {
              validPromoCodeDetails.emailCoupon = '';
            }

            dispatch(setPromoCode(validPromoCodeDetails));
          } else {
            dispatch(invalidPromoCode({ couponCode }));
            throw Error(errorMessage);
          }
        })
        .catch((error) => {
          dispatch(invalidPromoCode({ couponCode }));
          return onSubmitReactFormError(error.message, 401, 'Invalid coupon code');
        });
    }
    return dispatch(resetPromoCode());
  };
};

export const applyPromoCode = (couponCode) => {
  return async (dispatch) => {
    // if user enters the promo code, call evergent applyCouponV2 api
    if (couponCode) {
      return applyPromo(couponCode).then((response) => {
        const { isSuccess, errorMessage, isPaymentMethodError } = response;
        if (isSuccess) {
          const payload = {
            couponCode,
            hasApplied: true,
            validCouponCodeLabel: 'Code applied',
          };
          dispatch(setPromoCode(payload));
          return response;
        }
        dispatch(invalidPromoCode({ couponCode }));
        return { isPaymentMethodError, isSuccess, errorMessage };
      });
    }
    return dispatch(invalidPromoCode({ couponCode }));
  };
};
